export default __webpack_public_path__ + "static/media/suspended.58ac8f70.svg";